import { useLocale } from "@jmc/core/src/hooks/useLocale/index";
import { graphql, useStaticQuery } from "gatsby";

interface Disclaimer {
    title: string;
    text: string;
    cancel_button_text: string;
    ok_button_text: string;
}

interface ExternalLinkDisclaimer extends Disclaimer {
    whitelist_urls: string[];
}

export interface DisclaimerData {
    external_link_disclaimer?: ExternalLinkDisclaimer;
    external_event_disclaimer?: Disclaimer;
    medical_event_disclaimer?: Disclaimer;
    medical_content_disclaimer?: Disclaimer;
    scientific_publications_disclaimer?: Disclaimer;
    custom_disclaimer?: {
        cancel_button_text: string;
        ok_button_text: string;
        text: string;
        title: string;
        url: {
            href: string;
            title: string;
        }[];
    }[];
    publish_details?: {
        locale: string;
    };
}
export default function useDisclaimer(): DisclaimerData {
    const { allContentstackDisclaimers } = useStaticQuery(graphql`
        query {
            allContentstackDisclaimers {
                nodes {
                    medical_content_disclaimer {
                        title
                        text
                        ok_button_text
                        cancel_button_text
                    }
                    medical_event_disclaimer {
                        title
                        text
                        ok_button_text
                        cancel_button_text
                    }
                    external_event_disclaimer {
                        title
                        text
                        ok_button_text: login_button_text
                        cancel_button_text
                    }
                    external_link_disclaimer {
                        title
                        text
                        ok_button_text
                        cancel_button_text
                        whitelist_urls
                    }
                    scientific_publications_disclaimer {
                        title
                        text
                        ok_button_text
                        cancel_button_text
                    }
                    custom_disclaimer {
                        title
                        text
                        ok_button_text
                        cancel_button_text
                        url {
                            href
                            title
                        }
                    }
                    publish_details {
                        locale
                    }
                }
            }
        }
    `);
    const locale = useLocale();
    const localizedDisclaimer = allContentstackDisclaimers.nodes
        .filter((disclaimer: { publish_details: { locale: string } }) => disclaimer.publish_details.locale === locale)
        .pop();
    return localizedDisclaimer;
}
